import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie';
import instance from '../../Config/AxiosConfig';
import AddCommunitie from '../../Components/AddCommunitie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDelete } from '../../Context/ApiContext';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function StepTwo({ handleNext, handleBack }) {


    const [showProjectModal, setShowProjectModal] = useState(false);
    const [showCommunitieModal, setShowCommunitieModal] = useState(false);

    const handleProjectModalOpen = () => {
        setShowProjectModal(true);
    };

    const handleProjectModalClose = () => {
        setShowProjectModal(false);
    };
    const handleCommunitieModalOpen = () => {
        setShowCommunitieModal(true);
    };

    const handleCommunitieModalClose = () => {
        setShowCommunitieModal(false);
    };
    const [interest, setInterest] = useState([]);
    const [community, setCommunity] = useState([]);



    const [allInterest, setAllInterest] = useState([]);
    const [search, setSearch] = useState('')

    const fetchSearchInterests = async () => {


        const token = Cookies.get('token');
        let dat = {
            keyword: search
        }
        try {
            const response = await instance.get(`/interests/search/${dat.keyword}`, token);

            setAllInterest(response.data);

        }
        catch (error) {
            console.error('Erreur lors de la récupération des Communities:', error);
        };

    }

    useEffect(() => {

        fetchSearchInterests(); // Appeler handleSearch avec un événement fake
    }, [search]);


    const [isSubmitting, setIsSubmitting] = useState(false);

    const [checkedItems, setCheckedItems] = useState({});

    //checked interest
    const handleCheckboxChange = (event, interest) => {
        setCheckedItems({
            ...checkedItems,
            [interest.id]: event.target.checked
        });
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        const selectedInterests = Object.keys(checkedItems).filter(id => checkedItems[id]);

        try {
            setIsSubmitting(true);
            const requests = selectedInterests.map(id =>
                instance.get(`/interests/add/${id}`)
            );
            const responses = await Promise.all(requests);

            console.log('Responses:', responses);
            const allSuccessful = responses.every(response => response.status === 200);

            if (allSuccessful) {

                toast.success('Interest added successfully!', {
                    position: "top-center",

                    hideProgressBar: false,

                });


                const Interestsfiltred = allInterest.filter(interest => !selectedInterests.includes(interest.id.toString()));
                setAllInterest(Interestsfiltred);


                await fetchUserInterests();

                setShowProjectModal(false);
            }

        } catch (error) {
            console.error('Error adding interests:', error);

        } finally {
            setIsSubmitting(false);
        }
    };

    const fetchUserInterests = async () => {

        const token = Cookies.get('token');

        instance.get("/interests/interestsUser", token)
            .then(response => {
                setInterest(response.data);
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des interest:', error);
            });

    }

    const handleLogoutwithback = () => {
        Cookies.remove('token');
        Cookies.remove('userId')
        localStorage.removeItem('formNumber')
        localStorage.removeItem('userId')
        handleBack();

    };

    const { deleteItem, deleteResponse, join } = useDelete();

    const api1 = '/interests/delete';
    const api2 = '/communities/leave';

    useEffect(() => {
        fetchSearchInterests();
        fetchUserInterests();
    }, [deleteResponse]);





    const fetchCommunities = async () => {
        const token = Cookies.get('token');
        try {
            const response = await instance.get("/communities/getAll", token);


            setCommunity(response.data);
        } catch (error) {
            console.error('Erreur lors de la récupération des Communities:', error);
        }
    };



    useEffect(() => {

        fetchCommunities();

    }, [deleteResponse, join]);

    useEffect(() => {
        console.log(interest.length, 'Interest.length');
    }, [interest]);


    const style = {
        height: interest && interest.length > 0 ? "300px" : "auto",
        overflow: interest.length > 0 ? "scroll" : "hidden"
    };
    const stylecomm = {
        height: community && community.length > 0 ? "300px" : "auto",
        overflow: community.length > 0 ? "scroll" : "hidden"
    };

    return (
        <>

            <div className="tab-pane fade" id="nav-setting-tab-4 " style={{ opacity: 1 }}>
                {/* Communications START */}
                <div className="card my-5 ">
                    {/* Title START */}
                    <div className="card-header border-0 pb-0">
                        {/* <h5 className="card-title">Who can connect with you?</h5> */}
                        <p className="mb-0">Could you please provide your list of research interests? This information will be used to match you with relevant research communities. Thank you!.</p>
                    </div>
                    {/* Title START */}
                    {/* Card body START */}
                    <div className="card-body">
                        {/* Accordion START */}
                        <div className="accordion" id="communications">
                            {/* Accordion item */}
                            <div className="accordion-item bg-transparent">
                                <h2 className="accordion-header" id="communicationOne">
                                    <button className="accordion-button mb-0 h6" type="button" data-bs-toggle="collapse" data-bs-target="#communicationcollapseOne" aria-expanded="true" aria-controls="communicationcollapseOne">
                                       Resarch interests : {interest.length}

                                    </button>




                                </h2>
                                {/* Accordion info */}
                                <div id="communicationcollapseOne" className="accordion-collapse collapse show" aria-labelledby="communicationOne" data-bs-parent="#communications">


                                    <div className="row mt-3 scroll-hidden" style={style}>
                                        <div className="col-11 mx-auto">
                                            <div className="vstack gap-3">
                                                <ToastContainer style={{ marginTop: '100px', width: "max-content" }} />
                                                {interest &&
                                                    interest.length !== 0 ?
                                                    interest.map((interest, i) => {
                                                        return (
                                                            <div className="card card-body" key={i}>
                                                                <div className="d-md-flex justify-content-between align-items-center">

                                                                    <div className="mb-2 mb-md-0">

                                                                        <p className="small mb-0" >{interest.name}</p>
                                                                    </div>

                                                                    <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                                                        <a class="btn btn-danger-soft btn-sm" href="#!" onClick={() => deleteItem(api1, interest.id)}> delete </a>
                                                                    </div>
                                                                </div>


                                                            </div>
                                                        )
                                                    })
                                                    : < h5 className='bold fs-5 text-center ' >   there are no interests at the moment </h5>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer pt-0 text-end border-0 mt-3">
                                    <button type="button" className="btn btn-sm btn-ai me-3" onClick={handleProjectModalOpen}>
                                        <i className="fas fa-robot me-2"></i> ADD
                                    </button>


                                </div>
                            </div>

                            <div className="accordion-item bg-transparent">
                                <h2 className="accordion-header" id="communicationTwo">
                                    <button className="accordion-button mb-0 h6 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#communicationcollapseTwo" aria-expanded="false" aria-controls="communicationcollapseTwo">
                                        Community : {community.length}
                                    </button>

                                </h2>
                                <div id="communicationcollapseTwo" className="accordion-collapse collapse" aria-labelledby="communicationTwo" data-bs-parent="#communications">

                                    <div className="row mt-3 scroll-hidden" style={stylecomm}>
                                        <div className="col-11 mx-auto">
                                            <div className="vstack gap-3">
                                                {

                                                    community &&
                                                        community.length !== 0 ? community.map((com, i) => {
                                                            return (
                                                                <div className="card card-body" key={i}>
                                                                    <div className="d-md-flex justify-content-between align-items-center">

                                                                        <div className="mb-2 mb-md-0">

                                                                            <p className="small mb-0" >{com.name}</p>
                                                                        </div>

                                                                        <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                                                            <a class="btn btn-danger-soft btn-sm" href="#!" onClick={() => deleteItem(api2, com.id)}> Leave </a>
                                                                        </div>
                                                                    </div>


                                                                </div>
                                                            )
                                                        })
                                                        : < h5 className='bold fs-5 text-center ' >there is no community </h5>
                                                }
                                            </div>
                                        </div>
                                    </div>




                                </div>
                                <div className="card-footer pt-0 text-end border-0 mt-3">
                                    <button type="button" className="btn btn-sm btn-ai me-3" onClick={handleCommunitieModalOpen}>
                                        <i className="fas fa-robot me-2"></i> Join
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div className="d-flex justify-content-between">
                <button type="button" className="btn btn-sm btn-secondary" onClick={handleLogoutwithback} >Back</button>
                <button type="button" className="btn btn-sm btn-primary" onClick={handleNext}>Next</button>
            </div>
            {/* Modal add */}
            {/* Modal pour l'ajout d'interest' */}
            {showProjectModal &&
                <>


                    <Modal show={showProjectModal} onHide={handleProjectModalClose} style={{ marginTop: "50px" }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add new interest</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="inputSearch-container  " onSubmit={fetchSearchInterests}>
                                <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search interests..." className="inputSearch" name="text" type="text" />
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="iconss"><g stroke-width="0" id="SVGRepo_bgCarrier"></g><g stroke-linejoin="round" stroke-linecap="round" id="SVGRepo_tracerCarrier"></g><g id="SVGRepo_iconCarrier"> <rect fill="white"></rect> <path d="M7.25007 2.38782C8.54878 2.0992 10.1243 2 12 2C13.8757 2 15.4512 2.0992 16.7499 2.38782C18.06 2.67897 19.1488 3.176 19.9864 4.01358C20.824 4.85116 21.321 5.94002 21.6122 7.25007C21.9008 8.54878 22 10.1243 22 12C22 13.8757 21.9008 15.4512 21.6122 16.7499C21.321 18.06 20.824 19.1488 19.9864 19.9864C19.1488 20.824 18.06 21.321 16.7499 21.6122C15.4512 21.9008 13.8757 22 12 22C10.1243 22 8.54878 21.9008 7.25007 21.6122C5.94002 21.321 4.85116 20.824 4.01358 19.9864C3.176 19.1488 2.67897 18.06 2.38782 16.7499C2.0992 15.4512 2 13.8757 2 12C2 10.1243 2.0992 8.54878 2.38782 7.25007C2.67897 5.94002 3.176 4.85116 4.01358 4.01358C4.85116 3.176 5.94002 2.67897 7.25007 2.38782ZM9 11.5C9 10.1193 10.1193 9 11.5 9C12.8807 9 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5ZM11.5 7C9.01472 7 7 9.01472 7 11.5C7 13.9853 9.01472 16 11.5 16C12.3805 16 13.202 15.7471 13.8957 15.31L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L15.31 13.8957C15.7471 13.202 16 12.3805 16 11.5C16 9.01472 13.9853 7 11.5 7Z" clip-rule="evenodd" fill-rule="evenodd"></path> </g></svg>
                            </div>

                            <div className="row mt-3 scroll-hidden" style={{
                                height: " 350px",
                                overflow: "scroll"
                            }}>
                                <form className="row g-3 ms-2" onSubmit={handleSubmit}>


                                    {allInterest &&
                                        allInterest.map((interest, i) => {
                                            return (
                                                <div className="form-check form-check-md my-3" key={i}>
                                                    <input className="form-check-input"
                                                        type="checkbox"
                                                        id={`interest-${interest.id}`}
                                                        checked={checkedItems[interest.id] || false}
                                                        onChange={(e) => handleCheckboxChange(e, interest)} />
                                                    <label className="form-check-label" htmlFor={`interest-${interest.id}`}>{interest.name}</label>
                                                </div>

                                            )
                                        })

                                    }

                                </form>
                            </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button onClick={handleSubmit} disabled={isSubmitting} type="submit" className="btn btn-primary mb-0">{isSubmitting ? 'Saving...' : 'Save changes'}
                            </Button>

                        </Modal.Footer>


                    </Modal>

                </>}

            {/* Modal pour joindre community */}

            {
                showCommunitieModal && (
                    <AddCommunitie style={style} showCommunitieModal={showCommunitieModal} handleCommunitieModalClose={handleCommunitieModalClose} />
                )
            }






        </>
    )
}
 
export default StepTwo